/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ discount_plan_price: NonNullable<unknown> }} Onboarding_Paywall_Plan_Price_In_MonthInputs */

const en_onboarding_paywall_plan_price_in_month = /** @type {(inputs: Onboarding_Paywall_Plan_Price_In_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.discount_plan_price} / month)`)
};

const ar_onboarding_paywall_plan_price_in_month = /** @type {(inputs: Onboarding_Paywall_Plan_Price_In_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.discount_plan_price} / شهر)`)
};

const de_onboarding_paywall_plan_price_in_month = /** @type {(inputs: Onboarding_Paywall_Plan_Price_In_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.discount_plan_price} / Monat)`)
};

const es_onboarding_paywall_plan_price_in_month = /** @type {(inputs: Onboarding_Paywall_Plan_Price_In_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.discount_plan_price} / mes)`)
};

const fr_onboarding_paywall_plan_price_in_month = /** @type {(inputs: Onboarding_Paywall_Plan_Price_In_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.discount_plan_price} / mois)`)
};

const it_onboarding_paywall_plan_price_in_month = /** @type {(inputs: Onboarding_Paywall_Plan_Price_In_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.discount_plan_price} / mese)`)
};

const ja_onboarding_paywall_plan_price_in_month = /** @type {(inputs: Onboarding_Paywall_Plan_Price_In_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`（${i?.discount_plan_price}/月）`)
};

const ko_onboarding_paywall_plan_price_in_month = /** @type {(inputs: Onboarding_Paywall_Plan_Price_In_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.discount_plan_price}/월)`)
};

const pt_br_onboarding_paywall_plan_price_in_month = /** @type {(inputs: Onboarding_Paywall_Plan_Price_In_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.discount_plan_price}/mês)`)
};

const ru_onboarding_paywall_plan_price_in_month = /** @type {(inputs: Onboarding_Paywall_Plan_Price_In_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.discount_plan_price} / месяц)`)
};

const th_onboarding_paywall_plan_price_in_month = /** @type {(inputs: Onboarding_Paywall_Plan_Price_In_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.discount_plan_price} / เดือน)`)
};

const tr_onboarding_paywall_plan_price_in_month = /** @type {(inputs: Onboarding_Paywall_Plan_Price_In_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.discount_plan_price} / ay)`)
};

const zh_cn_onboarding_paywall_plan_price_in_month = /** @type {(inputs: Onboarding_Paywall_Plan_Price_In_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.discount_plan_price} / 月)`)
};

const zh_tw_onboarding_paywall_plan_price_in_month = /** @type {(inputs: Onboarding_Paywall_Plan_Price_In_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.discount_plan_price} / 月)`)
};

/**
* | output |
* | --- |
* | "({discount_plan_price} / month)" |
*
* @param {Onboarding_Paywall_Plan_Price_In_MonthInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_plan_price_in_month = /** @type {((inputs: Onboarding_Paywall_Plan_Price_In_MonthInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Plan_Price_In_MonthInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_plan_price_in_month(inputs)
	if (locale === "ar") return ar_onboarding_paywall_plan_price_in_month(inputs)
	if (locale === "de") return de_onboarding_paywall_plan_price_in_month(inputs)
	if (locale === "es") return es_onboarding_paywall_plan_price_in_month(inputs)
	if (locale === "fr") return fr_onboarding_paywall_plan_price_in_month(inputs)
	if (locale === "it") return it_onboarding_paywall_plan_price_in_month(inputs)
	if (locale === "ja") return ja_onboarding_paywall_plan_price_in_month(inputs)
	if (locale === "ko") return ko_onboarding_paywall_plan_price_in_month(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_plan_price_in_month(inputs)
	if (locale === "ru") return ru_onboarding_paywall_plan_price_in_month(inputs)
	if (locale === "th") return th_onboarding_paywall_plan_price_in_month(inputs)
	if (locale === "tr") return tr_onboarding_paywall_plan_price_in_month(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_plan_price_in_month(inputs)
	return zh_tw_onboarding_paywall_plan_price_in_month(inputs)
});